import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { dataUserSession, ipAddressSession } from './utilities/dataSession';
import { addDays, formatDateCounting_full, formatDateToken } from './utilities/DateUtil';
import { loginService } from './service/AUTH/LoginService';
import ValidateService from './components/ValidateService/ValidateService';
import { Toast } from 'primereact/toast';
import { TokenGenerate } from './service/AUTH/TokenService';

const AppTopbar = (props) => {

    const history = useHistory();

    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    const topbarMenuClassName = classNames('topbar-menu fadeInDown', { 'topbar-menu-visible': props.topbarMenuActive });
    const activeTopbarItemClassName = (name) => {
        return name === props.activeTopbarItem ? 'active-topmenuitem' : null;
    }

    const [dateTime, setDateTime] = useState({
        date: new Date()
    });


    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setDateTime({
                date: formatDateCounting_full(new Date(), true)
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);




    const onLogOutService = async () => {

        let userSession = dataUserSession() ? dataUserSession() : "";
        let ipAddress = ipAddressSession() ? ipAddressSession() : "";

        // if (ipAddress !== '' && ipAddress !== '') {

        let token = await onTokenGenerate()

        if (token && token !== "") {

            let data = {
                browser: "",
                ipAddress: "",
                loginLogout: "O",
                sessionId: ipAddress.sessionId,
                userId: userSession.userId,
                userPassword: "",
            };

            await loginService(data, token).then(
                (res) => {
                    if (res !== undefined && res.length > 0) {
                        if (res[0].statusCode === "C") {
                            history.push("/login");
                        } else if (res[0].statusCode === "E") {
                            showMessages(`${res[0].statusText}`);
                        }
                    } else {
                        showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                    }
                },
                function (err) {
                    setErrData(err)
                }
            );
        }
        // }
    };

    const onTokenGenerate = async () => {
        let token = ""
        let req = {
            apiKeyId: '',
            createBy: dataUserSession() ? dataUserSession().userId : "",
            createDt: formatDateToken(new Date(), true),
            desc: "Generate Access Token By Web Application",
            expireDt: formatDateToken(addDays(new Date(), 1), true), //dateToken, // dateToken.setDate(dateToken.getDate() + 1),
            remark: "Generate",
            role: "USER",
        }

        await TokenGenerate(req).then(
            (res) => {
                if (res != undefined) {
                    token = res
                } else {
                    showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );

        return token
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };


    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Toast ref={toast} position="top-right" />

            <div className="layout-topbar">
                <button className="layout-topbar-logo p-link" onClick={() => history.push('/')}>
                    <div style={{ display: 'flex' }}>
                        <img alt="babylon-layout" src="assets/layout/images/logo/icon2.png"
                            style={{ width: 50, height: 50, marginTop: -5, marginLeft: -8, marginRight: 6 }} />

                        <p className="label-hd" style={{ marginTop: '-10px' }}>
                            <span style={{ fontSize: '30px' }}>ระบบบริหารจัดการงานวางท่อ</span>
                        </p>
                    </div>
                    <div style={{ marginTop: '-20px', marginLeft: '50px', color: 'white' }}>
                        <span style={{ fontSize: '20px', }}>Pipeline Management System : PMS</span>
                    </div>
                    <br />

                </button>

                <button id="topbar-menu-button" className="p-link" onClick={props.onTopbarMenuButtonClick}>
                    <i className="pi pi-ellipsis-v"></i>
                </button>


                <ul className={topbarMenuClassName}>
                    <li className={activeTopbarItemClassName('settings')}
                        style={{ marginLeft: 2 }}
                    >
                        <button className="p-link" onClick={(e) => props.onTopbarItemClick(e, 'settings')}>
                            <i className="topbar-icon pi pi-cog"></i>
                            <span className="topbar-item-name" style={{ fontSize: '20px' }}>Settings</span>
                        </button>
                        <ul className={classNames({ 'fadeInDown': !props.isMobile() })}>
                            <li role="menuitem">
                                <button className="p-link" onClick={() => window.location = '#/003'}>
                                    <i className="pi pi-pencil"
                                    // style={{ fontSize: '18px' }}
                                    ></i>
                                    <span style={{ fontSize: '20px' }}>จัดการข้อมูล</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link" onClick={() => onLogOutService()}>
                                    <i className="pi pi-power-off"
                                    // style={{ fontSize: '18px' }}
                                    ></i>
                                    <span style={{ fontSize: '20px' }}>ออกจากระบบ</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                    <li
                        //  className={classNames({ 'active-topmenuitem': this.props.activeTopbarItem === 'messages' })}
                        className={activeTopbarItemClassName('settings')}
                        style={{ marginLeft: 2 }}
                        onClick={() => window.location = '#/'}>

                        <button className="p-link" >
                            <i className="topbar-icon pi pi-home" />
                            <span className="topbar-item-name" style={{ fontSize: '20px' }}>หน้าหลัก</span>
                        </button>
                    </li>

                    <li role="menuitem" style={{ marginTop: '10px', marginLeft: 10, color: 'white' }}>
                        <i className="topbar-icon pi pi-user" style={{ fontSize: '20px' }} />
                        <label style={{ marginLeft: '.5rem' }}> {(dataUserSession() != undefined && dataUserSession() != null ? dataUserSession().userFullName : '')} </label>
                    </li>
                    <li role="menuitem" style={{ marginTop: '10px', paddingRight: '10px', color: 'white' }}>
                        {/* <i className="topbar-icon pi pi-user" style={{ fontSize: '20px' }} /> */}
                        <label>{dateTime.date.toLocaleString()}</label>
                    </li>


                </ul>
            </div>

        </>
    );
}

export default AppTopbar;
